import moment from 'moment'

export const Util_isDateInRange = (
    startDate: moment.MomentInput,
    endDate: moment.MomentInput,
    date: moment.Moment = moment()
): boolean => {
    if (startDate && moment(startDate).diff(date) > 0) return false
    if (endDate && moment(endDate).diff(date) < 0) return false

    return true
}
